import type { Submission } from '../../lib/types'
import { count, pct, mean, f1 } from '../../lib/stats'

interface Props { data: Submission[] }

export function KpiStrip({ data }: Props) {
  const N = data.length
  const sigFields = ['signal_prolactin', 'signal_androgens', 'signal_insulin', 'signal_thyroid'] as const
  const anySignal  = count(data, d => sigFields.some(f => d[f] === 'signalled'))
  const avgScore   = mean(data.map(d => d.total_score))
  const avgPanels  = mean(data.map(d => d.investigation_gap.length))
  const t3count    = count(data, d => d.tier === 3)
  const t4count    = count(data, d => d.tier === 4)
  const pcosPct    = pct(count(data, d => d.previous_diagnoses.includes('pcos')), N)
  const cycleLens  = data.map(d => d.cycle_length_days).filter((v): v is number => v !== null)
  const meanCycle  = cycleLens.length ? f1(mean(cycleLens)) : '—'

  return (
    <div className="kpi-strip">
      <div className="kpi"><div className="kpi-v">{pct(anySignal, N)}%</div><div className="kpi-l">≥ 1 signal raised</div></div>
      <div className="kpi"><div className="kpi-v rose">{pct(t3count + t4count, N)}%</div><div className="kpi-l">Tier 3 + 4</div></div>
      <div className="kpi"><div className="kpi-v mint">{f1(avgScore)}</div><div className="kpi-l">Mean total score</div></div>
      <div className="kpi"><div className="kpi-v amber">{f1(avgPanels)}</div><div className="kpi-l">Mean panels / person</div></div>
      <div className="kpi"><div className="kpi-v violet">{pcosPct}%</div><div className="kpi-l">PCOS diagnosed</div></div>
      <div className="kpi"><div className="kpi-v">{meanCycle} d</div><div className="kpi-l">Mean cycle length</div></div>
    </div>
  )
}
